<template>
  <div class="page-shell">
    <div class="page-content">
      <Navigation />
      <div class="mainWrap">
        <div class="row mt-3">
          <div class="col-12">
            <h3>An error occurred</h3>
            <p class="link-danger">{{ error?.message }}</p>
            <a
              role="link"
              href=""
              tabindex="0"
              @click.prevent="reloadPage"
              @keydown.enter="reloadPage"
              >Reload</a
            >
            <br />
            <a href="/">Home</a
            ><!-- leaving a real link here instead of StoreLInk component in case of error -->
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
import Navigation from "~/components/shared/navigation/Navigation.vue";
import Footer from "~/components/shared/Footer.vue";

defineProps({
  error: {
    type: Object as () => NuxtError,
    default: null,
  },
});
const reloadPage = () => {
  window.location.reload();
};

onMounted(() => {
  console.debug("ErrorBoundary mounted");
});
</script>
